import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import {
  KVAnnotation,
  KVPolygonGeometry,
  RolodexEntryPatchJson,
  WorldPosition,
} from 'types'

import { KVMessageDef } from './index'

export function getUpdatePolygonMessage() {
  return {
    type: 'updatePolygon',
    requiredData: ['surfaceAreaId'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const targetId = json.surfaceAreaId as string
      if (!targetId) return

      const list = kv.annotations ?? []
      const annotation = list.find((a) => a.id === targetId)
      if (!annotation) return

      // Update area and perimeter if provided (values may arrive as strings)
      annotation.area = json.area ? parseFloat(json.area as string) : undefined
      annotation.perimeter = json.perimeter
        ? parseFloat(json.perimeter as string)
        : undefined

      // Update bounding box dimensions if provided
      if (json.boundingBoxLength !== undefined) {
        annotation.boundingBoxLength = parseFloat(
          json.boundingBoxLength as string
        )
      }
      if (json.boundingBoxWidth !== undefined) {
        annotation.boundingBoxWidth = parseFloat(
          json.boundingBoxWidth as string
        )
      }

      // Update geometry if points/normal provided
      if (json.surfaceAreaPoints && json.normal) {
        const polygonGeometry = new KVPolygonGeometry(
          json.surfaceAreaPoints as WorldPosition[],
          json.normal as WorldPosition
        )
        annotation.geometry = polygonGeometry
      }

      // Update severity if provided
      if (json.surfaceAreaSeverity) {
        annotation.severity = json.surfaceAreaSeverity as string
      }

      // Update centered values if provided
      if (json.normal) {
        annotation.centeredNormal = json.normal as WorldPosition
      }
      if (json.centeredPosition) {
        annotation.centeredPosition = json.centeredPosition as WorldPosition
      }

      if (json.inspectionArea) {
        annotation.tags = {
          ...annotation.tags,
          inspectionArea: {
            derivedTag: true,
            value: json.inspectionArea as string,
          },
        }
      }

      // Commit state update with a new array reference to ensure UI updates
      kv.setAnnotations([...(kv.annotations ?? [])])

      // Persist to rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kv.kestrelModel?.id ?? '',
        data: {
          annotations: kv.annotations?.map((a) => KVAnnotation.toJSON(a)) ?? [],
        },
      }
      kv.rolodexPatch([patchData])
    },
  } as KVMessageDef
}
